
interface ICoords {
	lat: number;
	lon: number;
}

interface IFotoPOIData {
	geomInLookup: boolean;
	id: number;
	mark: ICoords;
	markCamera: ICoords;
	markOrigin: ICoords;
	source: string;
	title: string;
	url?: string;
	urls?: Array<{
		url: string;
		urlType: string;
	}>;
	zoom: number;
}

/**
 * Marker detailu do mapy
 */
export default class Markers {
	_markers: Array<any>;

	_layerMarker: any;

	_smap: SMap;

	_coords: Array<any>;

	_signal: Array<string>;

	_extraMark: any;

	constructor(smap: SMap) {
		this._markers = [];
		this._curData = {};
		this._layers = {
			marker: new SMap.Layer.Marker(),
			dimm: new SMap.Layer.Marker(),
		};
		this._smap = smap;
		this._coords = [];
		this._signal = [];
		this._extraMark = null;

		this._signal.push(
			smap.getSignals().addListener(this, "marker-click", event => {
				this.handleEvent(event);
			}),
			smap.getSignals().addListener(this, "marker-poi-enter", event => {
				this.handleEvent(event);
			}),
			smap.getSignals().addListener(this, "marker-poi-leave", event => {
				this.handleEvent(event);
			}),
		);
	}

	destroy() {
		this.clear();

		for (const layer in this._layers) {
			if (this._layers[layer]) {
				this._layers[layer].$destructor();
			}
		}

		this._smap.getSignals().removeListeners(this._signal);
	}

	get layers() {
		return this._layers;
	}

	get coords(): Array<ICoords> {
		return this._coords;
	}

	addMarkers(data: Array<IFotoPOIData>, clear = false) {
		this._extraMark = null;

		if (clear) {
			const newData = {};
			const toRemove = [];

			data.forEach(newItem => {
				newData[`${newItem.source}${newItem.id}`] = 1;
			});

			Object.keys(this._curData).forEach(sourceId => {
				if (!(sourceId in newData)) {
					const marker = this._curData[sourceId];

					toRemove.push(marker);
					delete this._curData[sourceId];
				}
			});
			toRemove.length > 0 && this._layers.marker.removeMarker(toRemove);
		}

		// misto revers
		for (let ind = data.length - 1; ind >= 0; ind--) {
			const itemData = data[ind];
			const id = `${itemData.source}${itemData.id}`;

			if (!(id in this._curData)) {
				this._addMarker(itemData);
			}
		}

		this._layers.marker.redraw();
	}

	hover(source: string, id: number, data: IFotoPOIData) {
		let find = false;

		for (let index = 0; index < this._markers.length; index++) {
			const marker = this._markers[index];

			if (source && id && marker.getPlainId() === id && marker.getSource() === source) {
				const cont = marker.getContainer()[SMap.LAYER_MARKER];

				if (cont) {
					cont.classList.add("hover");
				}

				find = true;
			} else {
				const cont = marker.getContainer()[SMap.LAYER_MARKER];

				if (cont) {
					cont.classList.remove("hover");
				}

				if (this._extraMark) {
					this._layers.marker.removeMarker(this._extraMark);
					this._markers.splice(this._markers.indexOf(this._extraMark), 1);
					this._extraMark.$destructor();
					this._extraMark = null;
					this._layers.marker.redraw();
				}
			}
		}

		if (!find && data) {
			this._extraMark = this._addMarker(data);
			const cont = this._extraMark.getContainer()[SMap.LAYER_MARKER];

			if (cont) {
				cont.classList.add("hover");
			}

			this._layers.marker.redraw();
		}
	}

	handleEvent(event) {
		if (event.type === "marker-click" && event.data) {
			for (let index = 0; index < this._markers.length; index++) {
				const marker = this._markers[index];

				if (marker === event.target) {
					const customEvent = new CustomEvent("marker-click", {
						detail: {
							source: event.target.getSource(),
							id: event.target.getPlainId(),
						},
					});

					this._smap.getContainer().dispatchEvent(customEvent);
					customEvent.preventDefault();
					break;
				}
			}
		} else if (event.type === "marker-poi-enter") {
			const customEvent = new CustomEvent("marker-enter", {
				detail: {
					source: event.target.getSource(),
					id: event.target.getPlainId(),
				},
			});

			this._smap.getContainer().dispatchEvent(customEvent);
		} else if (event.type === "marker-poi-leave") {
			const customEvent = new CustomEvent("marker-leave", {
				detail: {
					source: event.target.getSource(),
					id: event.target.getPlainId(),
				},
			});

			this._smap.getContainer().dispatchEvent(customEvent);
		}
	}

	clear() {
		this._layers.marker.removeAll();

		while (this._markers.length) {
			const marker = this._markers.shift();

			marker.$destructor();
		}

		this._curData = {};
		this._extraMark = null;
		this._coords = [];
	}

	_addMarker(item: IFotoPOIData): any {
		const options:{
			title: string;
			url?: string;
		} = {
			title: item.title || "",
		};

		if (item.url) {
			options.url = Mapy.CDN.setSize(item.url, Mapy.CDN.SIZE_40_40);
		} else if (item.urls) {
			options.url = item.urls.filter(url => url.urlType === "placeholder")[0].url.replace("{width},{height},1", "40,40,3");
		}
		const mark = item.markCamera ? item.markCamera : item.mark;
		const coords = SMap.Coords.fromWGS84(mark.lon, mark.lat);
		const marker = new SMap.Marker.FotoPOI(coords, `${item.source}${item.id}`, options);
		const cont = marker.getContainer()[SMap.LAYER_MARKER];

		marker.setPlainId(item.id);
		marker.setSource(item.source);
		cont.classList.add("marker-foto");

		Array.from(cont.querySelectorAll("img")).forEach(el => el.setAttribute("crossorigin", "anonymous"));

		const link = cont.querySelector("a");

		if (link) {
			link.setAttribute("data-log-ignore", "1");
		}

		this._coords.push(coords);
		this._markers.push(marker);
		this._layers.marker.addMarker(marker, true);
		this._curData[`${item.source}${item.id}`] = marker;

		return marker;
	}
}
